<template>
    <hts-drawer
        v-model="visible"
        :submit="handleSubmitFormEditVehicle"
        :title="$t('labels.editVehicle')"
        size="large"
        :rules="rulesEditVehicle"
        @close="closeOverSide">
        <hts-card :title="$t('labels.generalInformation')">
            <div
                class="grid gap-4"
                :class="columnClass">
                <hts-form-input
                    v-model="dataFormEditVehicle.licensePlate"
                    :label="$t('labels.vehicleModule.licensePlate')"
                    :required="true"
                    :color="props.color"
                    name="vehicleModule.licensePlate"
                    prop="vehicleModule.licensePlate" />

                <hts-select-tracking-gps
                    v-model="dataFormEditVehicle.gpsTrackingType"
                    required
                    prop="gpsTrackingType"
                    name="gpsTrackingType"
                    :label="$t('labels.gpsTrackingType')" />
            </div>
        </hts-card>
        <hts-card :title="$t('labels.driverInfo')">
            <hts-card :title="$t('labels.primaryDriver')">
                <div
                    v-if="dataFormEditVehicle.otherCompanyDriver"
                    class="grid gap-4"
                    :class="columnClass">
                    <hts-form-input
                        v-model="dataFormEditVehicle.otherCompanyDriver.fullName"
                        :label="$t('labels.fullName')"
                        required
                        :color="color"
                        name="fullName"
                        prop="fullName" />
                    <hts-form-phone
                        v-model="dataFormEditVehicle.otherCompanyDriver.phone"
                        :label="$t('labels.phone')"
                        required
                        prop="phone"
                        name="phone"
                        @updateCode="(val) => (dataFormEditVehicle.otherCompanyDriver.phone.code = val)" />
                    <hts-form-input
                        v-model="dataFormEditVehicle.otherCompanyDriver.idCardNumber"
                        :label="$t('labels.idCardNumber')"
                        required
                        :color="color"
                        name="idCardNumber"
                        prop="idCardNumber" />
                    <hts-select-user
                        v-model="dataFormEditVehicle.otherCompanyDriver.companyUserId"
                        v-model:name="dataFormEditVehicle.otherCompanyDriver.companyUserName"
                        :label="$t('labels.userAccount')"
                        prop="companyUserId"
                        :data-create-default="dataFormEditVehicle"
                        creatable />
                </div>
            </hts-card>

            <hts-card
                v-if="openAddCoDriver"
                :title="$t('labels.coDriver')">
                <div
                    class="grid gap-4"
                    :class="columnClass">
                    <hts-form-input
                        v-model="dataFormEditVehicle.otherCompanyCoDriver.fullName"
                        :label="$t('labels.fullName')"
                        required
                        :color="color"
                        name="fullName"
                        prop="coDriverIdFullName" />
                    <hts-form-phone
                        v-model="dataFormEditVehicle.otherCompanyCoDriver.phone"
                        :label="$t('labels.phone')"
                        required
                        prop="coDriverIdphone"
                        name="phone"
                        @updateCode="(val) => (dataFormEditVehicle.otherCompanyCoDriver.phone.code = val)" />
                    <hts-form-input
                        v-model="dataFormEditVehicle.otherCompanyCoDriver.idCardNumber"
                        :label="$t('labels.idCardNumber')"
                        required
                        :color="color"
                        name="idCardNumber"
                        prop="coDriverIdCardNumber" />
                    <hts-select-user
                        v-model="dataFormEditVehicle.otherCompanyCoDriver.companyUserId"
                        v-model:name="dataFormEditVehicle.otherCompanyCoDriver.companyUserName"
                        :label="$t('labels.userAccount')"
                        prop="companyUserId"
                        :data-create-default="dataFormEditVehicle"
                        creatable />
                </div>
            </hts-card>

            <div>
                <hts-form-button
                    v-if="!openAddCoDriver"
                    color="primary"
                    size="small"
                    @click="handleAddCoDriver">
                    Thêm tài xế phụ
                </hts-form-button>

                <hts-form-button
                    v-if="openAddCoDriver"
                    color="error"
                    size="small"
                    @click="handleCloseCoDriver">
                    Bỏ tài xế phụ
                </hts-form-button>
            </div>
        </hts-card>
    </hts-drawer>
</template>

<script setup lang="ts">
import form, { IVehicle } from './imports/form'

const route = useRoute()
const id: string = route.query.id ? String(route.query.id) : ''

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 3
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['close', 'refreshDataTables'])

const dataFormEditVehicle = reactive<IVehicle>({ ...form.initFormVehicle } as IVehicle)
const visible = ref(false)
const openAddCoDriver = ref<boolean>(false)

const closeOverSide = () => {
  visible.value = false
  emits('close')
}

const openEditVehicle = async (vehicle: IVehicle) => {
  visible.value = true
  loading.value = true
  openAddCoDriver.value = false
  Object.assign(dataFormEditVehicle, { ...form.initFormVehicle })
  await getData(vehicle._id)
  nextTick(() => {
    loading.value = false
  })
}
defineExpose({
  openEditVehicle
})

const loading = ref(false)

const getData = async (id: string | undefined | String) => {
  const api = $urlPartner.vehicle.vehicle.getById
  await $api(api, { uriParams: { ID: id } }).then((data: any) => {
    const resData: any = data.data.value
    if (resData.success) {
      Object.assign(dataFormEditVehicle, resData.data)
      if (resData.data.otherCompanyCoDriver) {
        openAddCoDriver.value = true
      }
      delete dataFormEditVehicle.scheduleTimes
    }
  })
}

const handleSubmitFormEditVehicle = async () => {
  if (dataFormEditVehicle.type === 0 && !Object.keys(vehicleCategory.value).length) {
    // openPopupAddCategory.value = true
    return
  }

  if (dataFormEditVehicle.type !== 0) {
    dataFormEditVehicle.parkingNodeId = null
  }

  if (!openAddCoDriver.value) {
    delete dataFormEditVehicle.otherCompanyCoDriver
  }

  const api = $urlPartner.vehicle.vehicle.edit

  if (!dataFormEditVehicle.containerType) {
    dataFormEditVehicle.goodsType = []
    dataFormEditVehicle.coveringContainerLevel = ''
  }

  const data: any = await $api(api, {
    uriParams: { ID: dataFormEditVehicle._id },
    body: { ...dataFormEditVehicle }
  })
  const resData: any = data?.data?.value
  if (resData.success) {
    process.client && $toast().success(resData.data)
    emits('refreshDataTables')
    emits('close')
    visible.value = false
  }
}

const vehicleCategory = ref({})

const handleAddCoDriver = () => {
  if (!dataFormEditVehicle.otherCompanyCoDriver) {
    dataFormEditVehicle.otherCompanyCoDriver = {
      fullName: '',
      phone: {
        countryCode: 'Vietnam +84',
        phone: '',
        code: '+84'
      },
      idCardNumber: '',
      companyUserId: '',
      companyUserName: ''
    }
  }
  openAddCoDriver.value = true
}

const handleCloseCoDriver = () => {
  openAddCoDriver.value = false
}

const columnClass = computed(() => {
  switch (props.column) {
  case 1:
    return 'grid-cols-1'
  case 2:
    return 'grid-cols-2'
  case 3:
    return 'grid-cols-3'
  case 4:
    return 'grid-cols-4'
  case 5:
    return 'grid-cols-5'
  case 6:
    return 'grid-cols-6'
  case 7:
    return 'grid-cols-7'
  case 8:
    return 'grid-cols-8'
  case 9:
    return 'grid-cols-9'
  case 10:
    return 'grid-cols-10'
  case 11:
    return 'grid-cols-11'
  case 12:
    return 'grid-cols-12'
  }

  return 'grid-cols-1'
})

const rulesEditVehicle = computed(() => {
  if (!openAddCoDriver.value) {
    return {
      'vehicleModule.licensePlate': 'required',
      fullName: 'required',
      phone: 'required',
      idCardNumber: 'required'
    }
  }

  return {
    'vehicleModule.licensePlate': 'required',
    fullName: 'required',
    phone: 'required',
    idCardNumber: 'required',
    coDriverIdFullName: 'required',
    coDriverIdphone: 'required',
    coDriverIdCardNumber: 'required'
  }
})
</script>
